var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 2499.6 2500",
    viewBox: "0 0 2499.6 2500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1187.9 1187.9h-1187.9v-1187.9h1187.9z",
    fill: "#f1511b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m2499.6 1187.9h-1188v-1187.9h1187.9v1187.9z",
    fill: "#80cc28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m1187.9 2500h-1187.9v-1187.9h1187.9z",
    fill: "#00adef"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m2499.6 2500h-1188v-1187.9h1187.9v1187.9z",
    fill: "#fbbc09"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.e116a418f9c5f551889532b8c5095213.svg";
export { ForwardRef as ReactComponent };